import type { TranslationKey } from "../locales";
import type { Enums, Nullable } from "../types";

export function getUnitTranslationKey(unit: Nullable<Enums<"unit">>): TranslationKey {
	if (!unit) return "units.unit";
	switch (unit) {
		case "business-days":
			return "units.business_days";
		case "calendar-days":
			return "units.calendar_days";
		case "weeks":
			return "units.weeks";
		case "work-days":
			return "units.work_days";
		case "currency":
			return "units.currency";
		case "percent":
			return "units.percent";
		case "days":
			return "units.days";
		case "cubic-meters":
			return "units.cubic_meters";
		case "millimeters":
			return "units.millimeters";
		case "centimeters":
			return "units.centimeters";
		case "meters":
			return "units.meters";
		case "meters-week":
			return "units.meters_week";
		case "kilometers":
			return "units.kilometers";
		case "number":
			return "units.number";
		case "square-meters":
			return "units.square_meters";
		case "square-meters-week":
			return "units.square_meters_week";
		case "piece":
			return "units.piece";
		case "piece-week":
			return "units.piece_week";
		default:
			return "units.unit";
	}
}
